import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { STATES } from '../../../store/constants/clients';

import { create, update, get } from '../../../store/actions/facilities';
import { createFacilitySelector } from '../../../store/selectors/facilities';
import FacilityEditPageComponent from './FacilityEditPage';

const BillingProviderNPITemplate = {
    billingProviderNPI: '',
    providerCCN: '',
}

export const FacilityEditPage = connect(
    () => {
        const selectFacilityId = (state, props) => props.match.params.id;
        const selectMode = (state, props) => props.match.params.id === 'new' ? 'create' : 'edit';
        const selectFacility = createFacilitySelector(selectFacilityId);

        const mapBillingProviderNPIObject = (facility) => {
            if (facility && facility.billingProviderNpiDTO?.length > 0) {
                return facility.billingProviderNpiDTO.map(item => {
                    return {
                        ...item,
                        billingProviderNPI: item?.billingProviderNPI ?? '',
                        providerCCN: item?.providerCCN ?? '',
                    }
                })
            }
            return [BillingProviderNPITemplate]
        }

        function getFormattedState(state, states) {
            const foundState = states.find(item => item.displayName === state);
            return foundState ?? null
        }   

        function getInitialFormattedState(state, states) {
            const foundState = states.find(item => item.abbreviation === state);
            return foundState ?? null
        }   

        const selectInitialValues = createSelector(
            selectMode,
            selectFacility,
            (mode, facility) => {
                if (mode === 'edit' && facility) {
                    const payload = {
                        id: facility.id,
                        name: facility.name,
                        description: facility.description,
                        ein: facility.ein,
                        tin: facility.tin,
                        active: facility.active,
                        address: facility.address,
                        phone: facility.phone || '',
                        enableForPricer: facility.enableForPricer ?? false,
                        facilityNPI: facility.facilityNPI,
                        billingProviderNpiRequest: mapBillingProviderNPIObject(facility),
                        streetAddress: facility?.streetAddress || '',
                        state: getFormattedState(facility?.state, STATES) || '',
                        city: facility?.city || '',
                        zip: facility?.zip || '',
                        applyClientAddress:false,
                    }
                    return payload;
                }

                return {
                    name: '',
                    description: '',
                    ein: '',
                    tin: '',
                    address:'',
                    phone: '',
                    active: true,
                    enableForPricer: false,
                    facilityNPI:'',
                    billingProviderNpiRequest: mapBillingProviderNPIObject(null),
                    streetAddress: '',
                    state: '',
                    city:  '',
                    zip: '',
                    applyClientAddress:false,
                }
            }
        )

        return (state, props) => ({
            facilityCreatePending: state.facilities.create.pending,
            facilityUpdatePending: state.facilities.update.pending,
            facilityGetPending: state.facilities.get.pending,
            currentClient:state.dashboards.selectedClient,
            preferredDashboardClient:state?.session?.user?.preferredDashboardClientId,
            initialValues: selectInitialValues(state, props),
            mode: selectMode(state, props),
            STATES:STATES,
            getFormattedState:getInitialFormattedState,
            facility: (selectFacility as any)(state, props),
            facilityId: selectFacilityId(state, props),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            facilityCreate: create,
            facilityUpdate: update,
            facilityGet: get,
        }, dispatch)
    })
)(injectIntl(FacilityEditPageComponent));
